import { createComponent } from '@carvana/merch-components';

export const Container = createComponent('div', {
  className:
    'flex flex-col gap-4xl bg-background-default px-2xl py-4xl sm:gap-7xl sm:px-3xl sm:py-7xl lg:px-4xl'
});

export const Wrapper = createComponent('div', {
  className:
    'flex w-full max-w-[1272px] flex-col items-center gap-7xl bg-background-default xl:mx-auto'
});

export const InternalLinkModTitle = createComponent('h3', {
  className: 'text-center text-text-strong t-heading-lg sm:t-heading-xl'
});

export const GridWrapper = createComponent('div', {
  className:
    'grid w-full justify-items-center gap-x-2xl gap-y-xl sm:grid-cols-3'
});
